export default {
  BASE_URL: '/admin/crm/meeting',
  api: [
    {
      name: 'tabs',
      desc: '页签列表',
      method: 'GET',
      path: '/tabs'
    },
    {
      name: 'list',
      desc: '会议列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'save',
      desc: '新增或保存会议信息',
      method: 'POST',
      path: '/save'
    },
    {
      name: 'fields',
      desc: '必填字段信息',
      method: 'GET',
      path: '/required/fields'
    },
    {
      name: 'detail',
      desc: '会议详情',
      method: 'GET',
      path: '/detail'
    },
    {
      name: 'signList',
      desc: '报名信息详情列表',
      method: 'GET',
      path: '/sign/list'
    },
    {
      name: 'export',
      desc: '导出表格',
      method: 'GET',
      path: '/sign/export'
    },
    {
      name: 'modify',
      desc: '修改报名人数',
      method: 'POST',
      path: '/sign/modify'
    },
    {
      name: 'delete',
      desc: '删除会议',
      method: 'POST',
      path: '/delete'
    },
    {
      name: 'signDetail',
      desc: '会议报名信息',
      method: 'GET',
      path: '/sign/detail'
    },
    {
      name: 'commit',
      desc: '提交报名',
      method: 'POST',
      path: '/sign/commit'
    },
    {
      name: 'count',
      desc: '已报名人数',
      method: 'GET',
      path: '/sign/count'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/conference/index.js